import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExpressionEvaluatorService {

  evaluate(
    expression: string,
    context: any
  ): boolean {

    if (!expression) {
      return true;
    }

    try {

      return Function(
        'header',
        'line',
        `
          return (${expression});
        `
      )(
        context.header || {},
        context.line || {}
      );

    } catch (e) {

      console.error(
        'Expression Error',
        expression,
        e
      );

      return true;
    }
  }
}